import {isEmpty, map, uniqBy} from 'lodash';
import styles from "./ProductList.module.scss";
import ProductCard from "components/product/card/ProductCard";

const ProductList = ({products, title, relatedProducts}) => {
  if (isEmpty(products)) {
    return '';
  }

  let selectedProducts = products
    .filter((product) => {
      return product.photo;
    })
    .sort(() => 0.5 - Math.random())

  let finalArray = [];

  if(!isEmpty(relatedProducts)){
    map(relatedProducts,(product) => {
      selectedProducts.unshift(product);
    })
    finalArray = uniqBy(selectedProducts, 'id');
  }


  if (isEmpty(selectedProducts)) {
    return "";
  }

  return (
    <div className={styles['product-list']}>
      <div className="container">
        <h3 className={styles['product-list__title']}>
          {title}
        </h3>

        <div className={styles['product-list__products']}>
          {!isEmpty(finalArray) ? (
            <>
              {finalArray.slice(0,4).map((product, i) => {
                  return (
                    <div className={styles['product-list__product-col']} key={`product-list-col-${product.id}-${i}`}>
                      <ProductCard {...product}/>
                    </div>
                  )
                })}
            </>
          ) : (
            <>
              {selectedProducts.slice(0,4).map((product, i) => {
                return (
                  <div className={styles['product-list__product-col']} key={`product-list-col-${product.id}-${i}`}>
                    <ProductCard {...product}/>
                  </div>
                )
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductList;